import React from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils"; // for class merging
import { Badge } from "@/components/ui/badge"; // assume shadcn badge or make your own

const Tags = ({
  id,
  inferred = [],
  payload = [],
  onDelete,
  deleteItem,
  disabled = false,
  containerStyle = {},
  style = {},
}) => {
  const handleOnDelete = (indexToRemove, event) => {
    event.stopPropagation();
    const removableElement = payload[indexToRemove];
    const updatedPayload = [
      ...payload.slice(0, indexToRemove),
      ...payload.slice(indexToRemove + 1),
    ];
    onDelete?.(updatedPayload, removableElement);
  };

  const isObject = (item) => typeof item === "object" && item !== null;

  const getInferredStatus = (item, index) => {
    const inferredItem = inferred[index];
    return inferredItem?.v_inferred === true;
  };

  return (
    <div
      className={cn("flex flex-wrap gap-2 z-[999]", containerStyle)}
      style={style}
    >
      {Array.isArray(payload) &&
        payload.map((item, i) => {
          const isInferred = getInferredStatus(item, i);

          const label = isObject(item) ? (
            <div className="flex items-center gap-1">
              <span className="text-violet-700 text-sm">{item.subtitle}</span>
              <span className="text-gray-500 text-sm">: {item.label}</span>
            </div>
          ) : (
            <span className="text-sm">{item}</span>
          );

          const chipClasses = cn(
            "inline-flex items-center gap-1 px-2 py-1 rounded-full text-sm border",
            isInferred
              ? "bg-orange-500 text-white border-orange-600"
              : "bg-gray-100 dark:bg-gray-600 text-form-label border-gray-200 dark:border-gray-700",
            disabled && "opacity-50 pointer-events-none"
          );

          const chipContent = (
            <div className={chipClasses}>
              {label}
              {deleteItem && !disabled && (
                <button
                  type="button"
                  onClick={(e) => handleOnDelete(i, e)}
                  className="ml-1 text-white hover:text-red-100"
                >
                  <X size={14} className="shrink-0 text-form-label" />
                </button>
              )}
            </div>
          );

          return isInferred ? (
            <div
              key={`${id}-tooltip-${i}`}
              className="relative group"
              title="Yet to be approved by admin"
            >
              {chipContent}
            </div>
          ) : (
            <div key={`${id}-${i}`}>{chipContent}</div>
          );
        })}
    </div>
  );
};

export default Tags;
